import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ee22ba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-row w-full pt-2 pb-3 mt-10 divide-x divide-slate-300 border-b border-slate-300 relative",
  style: {"text-shadow":"white 1px 1px 0"}
}
const _hoisted_2 = { class: "mt-5 pb-12 w-1/3 text-center border-l border-slate-300" }
const _hoisted_3 = { class: "text-6xl font-bold leading-100 text-slate-700" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Total Portfolio Value", -1))
const _hoisted_5 = { class: "mt-5 pb-12 w-1/3 text-center" }
const _hoisted_6 = { class: "text-6xl font-bold leading-100 text-slate-700" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Total Portfolio Gain", -1))
const _hoisted_8 = { class: "w-1/3 text-center mt-5 pb-12 border-r border-slate-300" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-6xl font-bold leading-100 text-slate-700" }, "62.5%", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Below Last Shortage Peak", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative h-full bg-white p-3 text-gray-500 rounded-md text-left font-light text-sm" }, " Civilian ammo has gone through major shortage swings over the past fifteen years. The current market is roughly 65% below it's last peak. Click to learn more. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[1px] h-full absolute right-0 border-r bottom-3" }, null, -1))
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row grow bg-white p-2 border border-gray-300 mt-2"
}
const _hoisted_15 = { class: "font-mono leading-none opacity-50 pr-1 text-xs flex flex-row items-center" }
const _hoisted_16 = { class: "block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pt-10 mb-1 mt-8 font-ammocorps text-slate-500 text-2xl border-t" }, "Popular Markets", -1))
const _hoisted_18 = { class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WithTooltip = _resolveComponent("WithTooltip")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_FloatArrow = _resolveComponent("FloatArrow")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Float = _resolveComponent("Float")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_ProductOverlay = _resolveComponent("ProductOverlay")!
  const _component_CommodityRecord = _resolveComponent("CommodityRecord")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_BasicLayout = _resolveComponent("BasicLayout")!
  const _component_OverlayHowItWorksVideo = _resolveComponent("OverlayHowItWorksVideo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BasicLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_ContentWrapper, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_WithTooltip, null, {
                  tooltip: _withCtx(() => [
                    _createTextVNode(" Value of all ammo holdings in your account. Based on most recent executed USAE trade price for holdings you own. Does not include cash on hand. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_3, "$" + _toDisplayString(_ctx.millicents(_ctx.dashboard.portfolioValue / 100)), 1),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_WithTooltip, null, {
                  tooltip: _withCtx(() => [
                    _createTextVNode(" Change in value of your ammo holdings. Increase/decrease is difference between your original purchase price and most recent trade price on USAE of your holdings. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_ctx.dashboard.portfolioGain) + "% ", 1),
                          _createVNode(_component_InlineSvg, {
                            src: require(`@/assets/icons/arrow-up.svg`),
                            width: "20",
                            class: "inline relative -top-1.5"
                          }, null, 8, ["src"])
                        ]),
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Popover, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Float, {
                      show: _ctx.show,
                      placement: "bottom",
                      offset: 15,
                      arrow: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "w-full",
                          onMouseenter: _ctx.open,
                          onMouseleave: _ctx.delayClose
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _hoisted_10
                          ]),
                          _: 1
                        }, 8, ["onMouseenter", "onMouseleave"]),
                        _createVNode(_component_PopoverPanel, {
                          static: "",
                          class: "w-[340px] bg-white border border-gray-200 rounded-md shadow-lg focus:outline-none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FloatArrow, { class: "absolute bg-white w-5 h-5 rotate-45 border border-gray-200" }),
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["show"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_12
            ]),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{ name: 'RFL', key: 'rifle'}, { name: 'HND', key: 'handgun'}, { name: 'RMF', key: 'rimfire'}], (category) => {
              return _createElementVNode("div", _hoisted_13, [
                (_ctx.productsByGunTypeId[category.key])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                      _createElementVNode("li", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(category.name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsByGunTypeId[category.key], (product) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass([`${_ctx.productClass(product.id)} hover:${_ctx.productClassHover(product.id)}`, "grow"])
                        }, [
                          _createVNode(_component_ProductOverlay, {
                            productId: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: `/products/${product.id}`,
                                class: "block w-full h-5 border-l border-white"
                              }, null, 8, ["to"])
                            ]),
                            _: 2
                          }, 1032, ["productId"])
                        ], 2))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ])
            }), 64)),
            _hoisted_17,
            _createElementVNode("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodities, (commodity, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: commodity.id,
                  class: _normalizeClass([ i > 2 ? 'hidden sm:block' : ''])
                }, [
                  _createVNode(_component_CommodityRecord, {
                    id: commodity.id,
                    record: commodity,
                    marketSummary: _ctx.marketSummariesById[commodity.id]
                  }, null, 8, ["id", "record", "marketSummary"])
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayHowItWorksVideo)
  ], 64))
}